import React from 'react'

const PageTitleV2 = React.memo(({title,countText,count,unit}) => {
  return (
    <div className='pageTitleBox d-flex j-left a-end'>
      <h2 className="fs-32 fw-4 mt-5 mr-5">{ title }</h2>
      <p className="pb-5">{ countText }<span className="fc-blue fw-7">{ count }</span>{ unit }</p>
    </div>
  );
});

export default PageTitleV2;